import React, { useContext, useEffect, useRef, useState } from "react";
import SEO from '../components/SEO';
import styled, { css } from 'styled-components';
import { createNoise3D } from "simplex-noise";
import "./Home.css";
import img10 from '../components/assets/sai.jpg';
import img11 from '../components/assets/harshaprofile.jpg';
import img8 from '../components/assets/plus.png';
import profile from '../components/assets/madhu.jpg';
import arrow from '../components/assets/arrowhome.png';
import Abouthome from "../components/abouthome";
import Services from "../components/services";
import Project from "../components/project";
import Projectgalle from "../components/projectgalle";
import Horizontalscrollgasp from "../components/horizontalscrollgasp";
import Testimonials from "../components/Testimonials";
import Contact from "../components/contact";
import Srolltext from "../components/Srolltext";
import {
    motion,
} from "framer-motion"
import RefsContext from "../Refcontex";
import VideoHoverEffect from "./TextHoverEffect";
import Splitscreen from "./splitscreen";
import VideoBackground from "./VideoBackground";



const WavyBackgroundContainer = styled.div`
  position: relative;
  overflow: hidden;
  height: 100vh;
  background-color: #000;
`;

const Canvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;



const Container = styled.div`
  position: absolute;
  top: 70%;
  width: 100%;
  height: 15vh;
  align-items: center;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  perspective: 1000px;

  @media (max-width: 1200px) {
    top: 65%;
    height: auto;
    align-items: center;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;


const CardWrapper = styled(motion.div)`
  width: 18.75%;
  height: 14vh;
  /* Background Gradient */
  background: transparent;
  display: flex;
  flex-direction: column;
//   border: 1px solid  #000000 ;
  font-family: "Poppins", sans-serif;
  letter-spacing: 3px;
  font-weight: 100;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  transition: transform 0.5s;
  transform-style: preserve-3d;
  border-radius: 7vh;
  background:  ${({ backgroundColor }) => backgroundColor};
  ${(props) =>
        props.isHovered &&
        css`
      transform: rotateY(5deg) rotateX(5deg);
    `}
 @media (max-width: 1200px) {
    height: 8vh;
  }
`;

const CardWrapper1 = styled(motion.div)`
  height: 14vh;
  background: #FFCF96;
  display: flex;
  flex-direction: column;
  border: 1px solid  #000000 ;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  border-radius: 7vh;
 @media (max-width: 1200px) {
    height: auto;
  }
`;


const Text = styled.div`
    font-size: 1.2vw;
    line-height: 1.1;
    font-family: "Darker Grotesque", sans-serif;
    letter-spacing: 2px;
    font-weight: 600;
  margin-top: 10px;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  transition: transform 0.5s;
@media (min-width: 768px) and (max-width: 1200px) {
        font-size: 2.3vw;
        font-weight: 600;
    }
    @media (max-width: 767px) {
        font-size: 3.2vw;
        font-weight: 600;
    }
`;


const Stylednew = styled.span`
    display: inline;
    -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
    @media (min-width: 768px) and (max-width: 1200px) {
       display: none;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

const Styledmobile = styled.div`
    width: 10.5vw;
    height: 3vw;
  overflow: hidden;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  display: flex;
  @media (min-width: 768px) and (max-width: 1200px) {
       display: none;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

const Styledmobile2 = styled(motion.div)`
 display: none;
   -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
    @media (max-width: 1200px) {
       width: 26vw;
  height: 8vw;
  overflow: hidden;
  display: flex;
    }
`;

const Stylednew1 = styled.span`
    display: inline;
    @media (min-width: 768px) and (max-width: 1200px) {
       display: none;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;


const StyledImage = styled.img`
  height: 3.5vh;
  margin-bottom: 1.5vh;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  @media (max-width: 1200px) {
     display: none;
  }
`;

const WavyBackground = ({
    children,
    colors = ["#FE8E08", "#FE8E08", "#FE8E08", "#FD8C5E", "#FEB8B6"],
    waveWidth = 0.6,
    backgroundFill = "#EDE9E3",
    blur = 1,
    speed = "fast",
    waveOpacity = 0.7,
}) => {
    const noise = createNoise3D();
    let w, h, nt, i, x, ctx, canvas;
    const canvasRef = useRef(null);

    const getSpeed = () => {
        switch (speed) {
            case "slow":
                return 0.003;
            case "fast":
                return 0.003;
            default:
                return 0.003;
        }
    };

    const init = () => {
        canvas = canvasRef.current;
        ctx = canvas.getContext("2d");
        w = ctx.canvas.width = window.innerWidth;
        h = ctx.canvas.height = window.innerHeight;
        ctx.filter = `blur(${blur}px)`;
        nt = 0;
        window.onresize = function () {
            w = ctx.canvas.width = window.innerWidth;
            h = ctx.canvas.height = window.innerHeight;
            ctx.filter = `blur(${blur}px)`;
        };
        render();
    };

    const drawWave = (n) => {
        nt += getSpeed();
        for (i = 0; i < n; i++) {
            ctx.beginPath();
            ctx.lineWidth = waveWidth || 50;
            ctx.strokeStyle = colors[i % colors.length];
            for (x = 0; x < w; x += 5) {
                var y = noise(x / 800, 0.3 * i, nt) * 100;
                ctx.lineTo(x, y + h * 0.45);
            }
            ctx.stroke();
            ctx.closePath();
        }
    };

    let animationId;
    const render = () => {
        ctx.fillStyle = backgroundFill || "black";
        ctx.globalAlpha = waveOpacity || 0.5;
        ctx.fillRect(0, 0, w, h);
        drawWave(2);
        animationId = requestAnimationFrame(render);
    };

    useEffect(() => {
        init();
        return () => {
            cancelAnimationFrame(animationId);
        };
    }, []);

    const [isSafari, setIsSafari] = useState(false);
    useEffect(() => {
        setIsSafari(
            typeof window !== "undefined" &&
            navigator.userAgent.includes("Safari") &&
            !navigator.userAgent.includes("Chrome")
        );
    }, []);

    return (
        <WavyBackgroundContainer>
            <Canvas
                ref={canvasRef}
                id="canvas"
                style={{
                    ...(isSafari ? { filter: `blur(${blur}px)` } : {}),
                }}
            />
            <Content>{children}
            </Content>
        </WavyBackgroundContainer>
    );
};


const StyledDiv = styled(motion.div)`
  display: flex;
  height: 3.5vw;
  align-items: end;
  width: auto;
   margin-bottom: 1vw;

`;

const StyledDiv1 = styled(motion.div)`
  display: flex;
  height: 3.5vw;
  align-items: end;
  width: auto;
`;

const Why = styled.div`
  font-size: 4.2vw;
  color: #000;
  font-weight: 600;
  letter-spacing: 1px;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  font-family: "Darker Grotesque", sans-serif;
  line-height: 1;

   @media (min-width: 768px) and (max-width: 1200px) {
      font-size:  clamp(9vw, 6vw, 8vw);
    }
    @media (max-width: 767px) {
    font-size:  clamp(9vw, 6vw, 8vw);
    }
`;

const Teamdiv = styled.div`
  width: 3vw;
  height: 3vw;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  border-radius: 3vw;
   @media (min-width: 768px) and (max-width: 1200px) {
        width: 8vw;
        height: 8vw;
        border-radius: 4vw;
    }
`;

const Teamdiv1 = styled.div`
  width: 3vw;
  height: 3vw;
  border-radius: 3vw;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  margin-left: -0.5vw;
   @media (min-width: 768px) and (max-width: 1200px) {
        width: 8vw;
        height: 8vw;
        border-radius: 4vw;
        margin-left: -2vw;
    }
`;



const Home = () => {
    const [hiddenClass, setHiddenClass] = useState('');
    const [hiddenClassmobile, setHiddenClassmobile] = useState('');
    const { aboutRef, servicesRef, projectRef } = useContext(RefsContext);
    
    // Check if device is mobile
    const checkMobile = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        const isSmallScreen = window.innerWidth <= 768;
        return isMobileDevice || isSmallScreen;
    };

    const [showSplitscreen, setShowSplitscreen] = useState(() => {
        // Skip splitscreen on mobile
        if (checkMobile()) {
            return false;
        }
        return sessionStorage.getItem("splitscreen_shown") ? false : true;
    });

    useEffect(() => {
        if (showSplitscreen) {
            sessionStorage.setItem("splitscreen_shown", "true");

            // Disable scrolling
            document.body.style.overflow = "hidden";

            // Set a timeout to enable scrolling after a certain duration
            const scrollTimeout = setTimeout(() => {
                document.body.style.overflow = "auto"; // Re-enable scrolling
            }, 13000); // 5000ms = 5 seconds, adjust this duration as needed

            // Cleanup: Clear the timeout if the component unmounts or showSplitscreen changes
            return () => {
                clearTimeout(scrollTimeout);
                document.body.style.overflow = "auto"; // Ensure scroll is re-enabled
            };
        } else {
            document.body.style.overflow = "auto"; // Re-enable scrolling immediately if not showing Splitscreen
        }
    }, [showSplitscreen]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 1200) {
                setHiddenClass('hidden');
            } else {
                setHiddenClass('');
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const handleResizemobile = () => {
            if (window.innerWidth < 480) {
                setHiddenClassmobile('hidden');
            } else {
                setHiddenClassmobile('');
            }
        };

        window.addEventListener('resize', handleResizemobile);
        handleResizemobile(); // Initial check

        return () => {
            window.removeEventListener('resize', handleResizemobile);
        };
    }, []);

    return (
        <div style={{ overflowY: 'hidden' }}>
            <SEO
                title="Premier Software Development Company | Genzix"
                description="Genzix is a premier software development company specializing in web apps, mobile applications, custom AI automation, and cloud infrastructure solutions."
                keywords="software development company, software development, web design, mobile app development, AI automation, cloud infrastructure, digital transformation, UI/UX design, digital marketing, custom software, enterprise solutions, technology consulting"
                canonicalUrl="https://genzix.in/"
                ogTitle="Premier Software Development Company | Genzix"
                ogDescription="Genzix is a premier software development company specializing in web apps, mobile applications, custom AI automation, and cloud infrastructure solutions."
                ogImage="https://genzix.in/logo192.png"
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "Genzix",
                    "alternateName": "Genzix Software Development Company",
                    "url": "https://genzix.in",
                    "logo": "https://genzix.in/logo192.png",
                    "description": "Leading software development company specializing in web development, AI automation, cloud infrastructure, and digital transformation solutions.",
                    "foundingDate": "2020",
                    "address": {
                        "@type": "PostalAddress",
                        "addressCountry": "IN",
                        "addressRegion": "India"
                    },
                    "contactPoint": {
                        "@type": "ContactPoint",
                        "telephone": "+91-9381048755",
                        "contactType": "Customer Service",
                        "email": "teamgenzix@gmail.com",
                        "url": "https://genzix.in/contactus"
                    },
                    "sameAs": [
                        "https://www.instagram.com/genzix.in/",
                        "https://www.linkedin.com/company/genzix.in/about/",
                        "https://twitter.com/genzix",
                        "https://github.com/genzix"
                    ],
                    "service": [
                        {
                            "@type": "Service",
                            "name": "Web Development",
                            "description": "Custom web applications and websites built with modern technologies"
                        },
                        {
                            "@type": "Service", 
                            "name": "Mobile App Development",
                            "description": "Native and cross-platform mobile applications for iOS and Android"
                        },
                        {
                            "@type": "Service",
                            "name": "AI Automation",
                            "description": "Artificial intelligence solutions and automation services"
                        },
                        {
                            "@type": "Service",
                            "name": "Cloud Infrastructure",
                            "description": "Cloud migration, setup, and management services"
                        }
                    ],
                    "areaServed": {
                        "@type": "Country",
                        "name": "Worldwide"
                    }
                }}
                faqData={[
                    {
                        question: "What services does Genzix offer?",
                        answer: "Genzix offers comprehensive software development services including web development, mobile app development, AI automation, cloud infrastructure, UI/UX design, and digital marketing solutions."
                    },
                    {
                        question: "How experienced is the Genzix team?",
                        answer: "Our team has extensive experience in software development, with expertise in modern technologies and frameworks. We've successfully delivered 100+ projects for businesses worldwide."
                    },
                    {
                        question: "What technologies does Genzix use?",
                        answer: "We use cutting-edge technologies including React, Node.js, Python, AI/ML frameworks, cloud platforms like AWS and Azure, and modern development tools to deliver high-quality solutions."
                    }
                ]}
            />
            <h1 className="visually-hidden">Genzix — Software Development, Web, Mobile App &amp; AI Solutions</h1>
            {/* <WavyBackground style={{ height: '100vh' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <StyledDiv initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }} style={{ marginTop: hiddenClass ? (hiddenClassmobile ? '-5vh' : '-13vh') : '-10vh' }}>
                        <Why >Ignite your <Stylednew style={{ color: 'black' }}>digital</Stylednew></Why>
                    </StyledDiv>
                    {hiddenClass ? (
                        <StyledDiv1 initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
                            style={{ marginTop: '3vh' }}>
                            <Why >digital presence with us</Why>

                        </StyledDiv1>
                    ) : (
                        <StyledDiv1 initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}>
                            <Why > presence<span className="space why"></span></Why>
                            <StyledImage src={arrow} alt="GIF" />
                            <Why><Stylednew1 className="space "></Stylednew1>with us<span className="space "></span></Why>
                            <Styledmobile >
                                <Teamdiv style={{ background: '#EDE9E3', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #000', overflow: 'hidden' }}>
                                    <img height='100%' width='100%' src={profile} alt="" />
                                </Teamdiv>
                                <Teamdiv1 style={{ background: '#E3E7EE', position: 'relative', overflow: 'hidden', border: '1px solid #000', }}>
                                    <img height='100%' width='100%' src={img10} alt="" /> </Teamdiv1>
                                <Teamdiv1 style={{ background: '#E3E7EE', position: 'relative', overflow: 'hidden', border: '1px solid #000', }}>
                                    <img height='100%' width='100%' src={img11} alt="" /> </Teamdiv1>
                                <Teamdiv1 style={{ background: '#EDE9E3', position: 'relative', border: '1px solid #000', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                                    <img height='50%' src={img8} alt="" loading="lazy" />
                                </Teamdiv1>
                            </Styledmobile>

                        </StyledDiv1>
                    )}
                    <Styledmobile2 initial={{ opacity: 0, y: 50 }}
                        style={{ marginTop: '2vh' }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}>
                        <div style={{ width: '8vw', height: '8vw', background: '#EDE9E3', borderRadius: '4.5vw', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #000', overflow: 'hidden' }}>
                            <img height='100%' width='100%' src={profile} alt="" />
                        </div>
                        <div style={{ width: '8vw', height: '8vw', background: '#E3E7EE', borderRadius: '4.5vw', position: 'relative', marginLeft: '-2vw', overflow: 'hidden', border: '1px solid #000', }}>
                            <img height='100%' width='100%' src={img10} alt="" /> </div>
                        <div style={{ width: '8vw', height: '8vw', background: '#E3E7EE', borderRadius: '4.5vw', position: 'relative', marginLeft: '-2vw', overflow: 'hidden', border: '1px solid #000', }}>
                            <img height='100%' width='100%' src={img11} alt="" /> </div>
                        <div style={{ width: '8vw', height: '8vw', background: '#FFCF96', borderRadius: '4.5vw', position: 'relative', marginLeft: '-2vw', border: '1px solid #000', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                            <img height='50%' src={img8} alt="" />
                        </div>

                    </Styledmobile2>
                </div>
                <Container>
                    {hiddenClass ? (
                        <div style={{ width: '100%', height: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'start', flexDirection: 'column' }}>
                            <div style={{ width: '100%', height: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zindex: '2' }}>
                                <CardWrapper1
                                    initial={{ opacity: 0, y: 70 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.2, ease: "easeOut", delay: 0.8 }}
                                    style={{ marginLeft: '5%', width: '42.5%', zindex: '2' }}
                                >
                                    <Text style={{ color: '#000', textAlign: 'center', marginTop: '10px', marginBottom: '10px' }}>Web & App <br /> Development</Text>
                                </CardWrapper1>
                                <CardWrapper1
                                    initial={{ opacity: 0, x: '-110%' }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: 1.2 }}
                                    style={{ width: '42.5%', marginRight: '5%', zindex: '2' }}
                                >
                                    <Text style={{ color: '#000', textAlign: 'center', marginTop: '10px', marginBottom: '10px' }}>UI/UX <br />DESIGN</Text>
                                </CardWrapper1>
                            </div>
                            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.5vh', zindex: '0' }}>
                                <CardWrapper1
                                    initial={{ opacity: 0, y: 70 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.2, ease: "easeOut", delay: 0.8 }}
                                    style={{ marginLeft: '5%', width: '42.5%', zindex: '0' }}
                                >
                                    <Text style={{ color: '#000', textAlign: 'center', marginTop: '10px', marginBottom: '10px' }}>Digital <br />Marketing</Text>
                                </CardWrapper1>
                                <CardWrapper1
                                    initial={{ opacity: 0, x: '-110%' }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: 1.2 }}
                                    style={{ marginRight: '5%', width: '42.5%', zindex: '0' }}
                                >
                                    <Text style={{ color: '#000', textAlign: 'center', marginTop: '10px', marginBottom: '10px' }}> Brand <br /> management</Text>
                                </CardWrapper1>
                            </div>

                        </div>
                    )
                        :
                        (
                            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <CardWrapper
                                    initial={{ opacity: 0, y: 70 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.2, ease: "easeOut", delay: 0.8 }}
                                    className="border-gradient border-gradient-purple"
                                    backgroundColor="#FFCF96"
                                    style={{ marginLeft: '5%', zIndex: '4' }}
                                >
                                    <div style={{ height: '100%', width: '100%', background: 'transparent', border: '1px solid #000', borderRadius: '7vh', position: 'absolute', top: '0', left: '0', zIndex: '1' }} />
                                    <Text className='abouthomebox' style={{ color: '#000', textAlign: 'center', marginTop: '-2px', zIndex: '2' }}>Web & APP <br /> DEVELOPMENT</Text>
                                </CardWrapper>
                                <CardWrapper
                                    initial={{ opacity: 0, x: '-125%' }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.4, ease: "easeOut", delay: 1.2 }}
                                    backgroundColor="#FFCF96"
                                    style={{ zIndex: '3', }}
                                >


                                    <div style={{ height: '100%', width: '100%', background: 'transparent', border: '1px solid #000', borderRadius: '7vh', position: 'absolute', top: '0', left: '0', zIndex: '1' }} />
                                    <Text className='abouthomebox' style={{ color: '#000', textAlign: 'center', marginTop: '-2px' }}>UI/UX<br />DESIGN</Text>
                                </CardWrapper>
                                <CardWrapper
                                    initial={{ opacity: 0, x: '-125%' }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.4, ease: "easeOut", delay: 1.8 }}
                                    backgroundColor="#FFCF96"
                                    style={{ zIndex: '2', }}
                                >

                                    <div style={{ height: '100%', width: '100%', background: 'transparent', border: '1px solid #000', borderRadius: '7vh', position: 'absolute', top: '0', left: '0', zIndex: '1' }} />
                                    <Text className='abouthomebox' style={{ color: '#000', textAlign: 'center', marginTop: '-2px' }}>Digital <br />Marketing</Text>

                                </CardWrapper>
                                <CardWrapper
                                    initial={{ opacity: 0, x: '-125%' }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.4, ease: "easeOut", delay: 2.4 }}
                                    backgroundColor="#FFCF96"
                                    style={{ zIndex: '1', marginRight: '5%' }}
                                >

                                    <div style={{ height: '100%', width: '100%', background: 'transparent', border: '1px solid #000', borderRadius: '7vh', position: 'absolute', top: '0', left: '0', zIndex: '1' }} />

                                    <Text className='abouthomebox' style={{ color: '#000', textAlign: 'center', marginTop: '-2px', zIndex: '2' }}>Brand <br /> management</Text>
                                </CardWrapper>
                            </div>
                        )}

                </Container>
            </WavyBackground > */}
           {showSplitscreen ? <Splitscreen /> : <VideoBackground />}
            <div ref={aboutRef}>
                <Srolltext />
            </div>

            <Abouthome />
            <div ref={servicesRef}>
                <Services />
            </div>
            <div ref={projectRef}>
                <Project />
            </div>
            {hiddenClass ? (
                <Projectgalle />
            ) : (<></>)}
            {/* <Projectgalle /> */}
            {hiddenClass ? (
                <></>
            ) : (<Horizontalscrollgasp />)}
            <Testimonials />
            <Contact />

        </div >



    );
};

export default Home;
